module.exports = __webpack_public_path__ + "static/img/banner05.2c78dc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner05.png
// module id = m8Fn
// module chunks = 1